import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {IonSlides, ModalController} from '@ionic/angular';
import {TranslateService} from '@ngx-translate/core';
import {OnEnter} from '../../../../_interface/on.enter';
import {Subscription} from 'rxjs';
import {UserService} from '../../../../_services';
import {Location} from '@angular/common';

@Component({
  selector: 'app-why-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent implements OnInit, OnEnter, OnDestroy {

  @ViewChild('slides', {static: true}) slider: IonSlides;
  segment = 0;
  reports = [];
  private subscription: Subscription;

  constructor(public router: Router,
              private userService: UserService,
              private location: Location,
              private activatedRoute: ActivatedRoute,
              public translate: TranslateService,
              public modalController: ModalController) {
  }

  async segmentChanged() {
    await this.slider.slideTo(this.segment);
  }

  async slideChanged() {
    this.segment = await this.slider.getActiveIndex();
  }

  async ngOnInit() {
    this.activatedRoute.params.subscribe(params => {
      if (Object.keys(params).length === 0) {
        this.segment = 0;
        return;
      }
      if (params.page) {
        this.segment = params.page;
        this.segmentChanged();
      }
    });
    await this.onEnter();
    this.subscription = this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd && event.url === '/profile') {
        this.onEnter();
      }
    });
  }

  async onEnter(): Promise<void> {
    this.getMyEmotionReports();
    // this.getNotificationCount();
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getMyEmotionReports() {
    this.userService.getMyEmotionReport()
      .subscribe((data) => {
        this.reports = data.reports;
      }, (error) => {
        console.error(error);
      });
  }

  back() {
    this.location.back();
  }
}
